import { Box, Button, CardContent, Checkbox, FormControlLabel, Grid, Paper, Typography, useTheme } from '@mui/material';
import MainCard from 'ui-component/cards/MainCard';
import AssuredWorkloadIcon from '@mui/icons-material/AssuredWorkload';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import AllianceServices from '../services/AllianceServices';
import { showConfirmAlert } from 'ui-component/Alerts/SweetAlerts';
import { AllianceConfidentiality } from './AllianceConfidentiality';

const AllianceConfirm = ({ openSnackbar, handleReload }) => {
  const theme = useTheme();
  const [isConfirmed, setIsConfirmed] = useState(false);
  const { user } = useSelector((state) => state.user);

  const handleConfirmationChange = (event) => {
    setIsConfirmed(event.target.checked);
  };

  const confirmAlliance = async () => {
    try {
      if (isConfirmed) {
        const confirmationResponse = await AllianceServices.confirmAlliance(user?.uid);
        const message = confirmationResponse?.success
          ? '¡El acuerdo de confidencialidad se ha confirmado exitosamente!'
          : 'Hubo un error al confirmar el acuerdo de confidencialidad.';
        const severity = confirmationResponse?.success ? 'success' : 'error';
        openSnackbar(message, severity);
        handleReload();
      } else {
        openSnackbar('Por favor, acepta los términos del acuerdo de confidencialidad.', 'error');
      }
    } catch (error) {
      console.error('Error al confirmar la alianza:', error);
    }
  };

  const confirmAllianceWithAlert = async () => {
    try {
      showConfirmAlert(
        'Confirmar Acuerdo',
        '¿Estás seguro de confirmar este acuerdo de confidencialidad?',
        'Confirmar',
        'info',
        confirmAlliance
      );
    } catch (error) {
      console.error('Error al mostrar el diálogo de confirmación:', error);
    }
  };

  return (
    <MainCard
      style={{ marginTop: '20px', paddingBottom: '5px' }}
      title={
        <Grid container justifyContent={'center'} alignItems={'center'}>
          <Grid item xs={12}>
            <Typography variant="h1" component="h2">
              Acuerdo de confidencialidad
            </Typography>
            <Typography variant="h4"> Confirma acuerdo de confidencialidad </Typography>
          </Grid>
        </Grid>
      }
      secondary={
        <Grid container justifyContent={'center'}>
          <Box>
            <AssuredWorkloadIcon sx={{ fontSize: '60px' }} color={theme.palette.grey[500]} />
          </Box>
        </Grid>
      }
    >
      <CardContent>
        <Paper elevation={0} sx={{ maxHeight: 500, overflowY: 'auto', bgcolor: 'transparent', border: 'none' }}>
          <AllianceConfidentiality />
        </Paper>

        <FormControlLabel
          label="He leído y acepto los términos del acuerdo de confidencialidad"
          control={<Checkbox checked={isConfirmed} onChange={handleConfirmationChange} inputProps={{ 'aria-label': 'controlled' }} />}
        />

        <Grid container justifyContent="flex-end">
          <Button variant="contained" color="primary" disabled={!isConfirmed} onClick={confirmAllianceWithAlert} sx={{ mt: 2 }}>
            Confirmar
          </Button>
        </Grid>
      </CardContent>
    </MainCard>
  );
};

export default AllianceConfirm;
